import { render, staticRenderFns } from "./Carrito.vue?vue&type=template&id=47a38734&scoped=true"
import script from "./Carrito.vue?vue&type=script&lang=js"
export * from "./Carrito.vue?vue&type=script&lang=js"
import style0 from "./Carrito.vue?vue&type=style&index=0&id=47a38734&prod&lang=css&scoped=true"
import style1 from "./Carrito.vue?vue&type=style&index=1&id=47a38734&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a38734",
  null
  
)

export default component.exports